module.exports = __webpack_public_path__ + "img/gleam-hero_lg.475d32f.webp";